import React from "react";
import { EntityCrudPage } from "./EntityCrudPage";

export function MediaPage() {
  return (
    <EntityCrudPage
      title="Media"
      subtitle="Manage media links and details."
      endpoint="/api/Media"
      listColumns={[
        { key: "title", label: "Title" },
        { key: "description", label: "Description" },
        { key: "youtubeVideoCode", label: "Youtube Video Code" }
      ]}
      fields={[
        { key: "title", label: "Title", required: true },
        { key: "description", label: "Description", type: "textarea" },
        { key: "youtubeVideoCode", label: "Youtube Video Code" }
      ]}
    />
  );
}
